<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-if="technical_details != null"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickOk"
                >
                    Ok
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="padding-top: 15px"
        >

            <div
                v-for="(item, index) in technical_details.details"
                :key="'td_'+index"
            >
                <h2 style="margin-bottom: 15px; margin-top: 15px">{{item.header}}</h2>
                <div
                    style="padding-left: 25px"
                >
                    <p
                        v-if="item.text != null"
                        v-html="$rc.htmlLinebreak(item.text)"
                    />
                        
                    
                    <code
                        v-if="item.json != null"
                        style="display: block; white-space: pre;"
                        v-html="JSON.stringify(item.json, null, 5)"
                    />

                    <code
                        v-if="item.exception != null"
                        style="display: block; white-space: pre; margin-bottom: 15px;"
                        v-html="$rc.escapeHTML(item.exception)"
                    />

                    <div
                        v-if="item.json_before != null || item.json_after != null"
                        style="margin-bottom: 15px"
                    >
                        For help comparing before and after, use <a href="https://jsoncompare.org/" target="_blank">https://jsoncompare.org/</a> 
                        
                        
                        <a style="margin-left: 15px" v-on:click="$rc.copy(JSON.stringify(item.json_before ?? '{}', null, 5))">Copy Before</a>
                        <a style="margin-left: 15px" v-on:click="$rc.copy(JSON.stringify(item.json_after ?? '{}', null, 5))">Copy After</a>
                        
                    </div>

                    <v-row
                        v-if="item.json_before != null || item.json_after != null"
                    >
                        <v-col>
                            <code
                                style="display: block; white-space: pre;"
                                v-html="JSON.stringify(item.json_before ?? '{}', null, 5)"
                            />
                        </v-col>

                        <v-col>
                            <code
                                style="display: block; white-space: pre;"
                                v-html="JSON.stringify(item.json_after ?? '{}', null, 5)"
                            />
                        </v-col>

                    </v-row>
                    
                </div>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,

            title: null,
            technical_details: null,
        }
    },

    created () {
        this.$event_bus.$on('technical_details', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('technical_details',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.title = params.title ?? 'Technical Details';
            this.technical_details = params.technical_details;

            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickOk()
        {
            this.closeDialog();
        },

    },
}
</script>

<style lang="scss" scoped>
</style>